var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2308 0H1.38462C0.619918 0 0 0.619918 0 1.38462C0 2.14931 0.619918 2.76923 1.38462 2.76923H15.2308C15.9955 2.76923 16.6154 2.14931 16.6154 1.38462C16.6154 0.619918 15.9955 0 15.2308 0Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6154 6.23077H1.38462C0.619918 6.23077 0 6.85069 0 7.61539C0 8.38009 0.619918 9 1.38462 9H16.6154C17.3801 9 18 8.38009 18 7.61539C18 6.85069 17.3801 6.23077 16.6154 6.23077Z",
    fill: "#49712B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3846 12.4615H1.38461C0.619918 12.4615 0 13.0815 0 13.8462C0 14.6109 0.619918 15.2308 1.38461 15.2308H10.3846C11.1493 15.2308 11.7692 14.6109 11.7692 13.8462C11.7692 13.0815 11.1493 12.4615 10.3846 12.4615Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.36eaf90da8537cafecdfe80180d5732b.svg";
export { ForwardRef as ReactComponent };